export default "__VITE_ASSET__D3C6PguN__"